/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Discard2Inputs */

const en_coinvestments_dataroom_discard2 = /** @type {(inputs: Coinvestments_Dataroom_Discard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Coinvestments_Dataroom_Discard2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_discard2 = /** @type {((inputs?: Coinvestments_Dataroom_Discard2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Discard2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_discard2(inputs)
});
export { coinvestments_dataroom_discard2 as "coInvestments_dataRoom_discard" }